import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import { routes } from 'lib/routes'
import React, { PropsWithChildren } from 'react'

interface Props {
  url?: string
  venueSlug?: string
}

export const LinkOrRoute = ({
  url,
  venueSlug,
  children,
}: PropsWithChildren<Props>) => {
  if (url) {
    return (
      <a href={url} style={{ display: 'block' }}>
        {children}
      </a>
    )
  }

  return (
    <RouteLink
      key={venueSlug}
      route={routes.venue}
      pathData={{ venueSlug: venueSlug! }}
    >
      <a>{children}</a>
    </RouteLink>
  )
}
